export class Service {
    constructor(
        public readonly id: number,
        public readonly entityId: number,
        public name: string,
        public description: string,
        public catalogue?: string,
    ) {}
}
